/**
 * F5: DEUDOR en remitos Vtas — password del vendedor logueado.
 * Run: npx tsx --test src/lib/remitoDeudorPassword.test.ts
 */

export function remitoDeudorNecesitaPassword(remito: {
  esDeudor?: boolean;
  es_deudor?: boolean;
}): boolean {
  return Boolean(remito.esDeudor ?? remito.es_deudor);
}

export function remitoEntregaBody(opts: {
  items?: unknown[];
  depositoId?: number;
  password?: string;
}): Record<string, unknown> {
  const body: Record<string, unknown> = { items: opts.items || [] };
  if (opts.depositoId != null) body.depositoId = opts.depositoId;
  const pwd = (opts.password || "").trim();
  if (pwd) body.password = pwd;
  return body;
}
